import { render, staticRenderFns } from "./edit_covert_face_form.vue?vue&type=template&id=48a354df"
import script from "./edit_covert_face_form.vue?vue&type=script&lang=js"
export * from "./edit_covert_face_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports